import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LocationSearchControl = _resolveComponent("LocationSearchControl")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", _mergeProps({ type: "hidden" }, _ctx.$props, {
      value: JSON.stringify(_ctx.currentValue)
    }), null, 16, _hoisted_1),
    _createVNode(_component_LocationSearchControl, {
      value: _ctx.currentValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentValue = $event)),
      placeholder: _ctx.$props.placeholder
    }, null, 8, ["value", "placeholder"])
  ]))
}